import React, { useEffect, useState } from "react";
import styled from "styled-components";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import LogoWithText from "../../assets/logo/LogoWithText.png";
import BurgerIcon from "../../assets/svg/BurgerIcon";

const TABS = [
  ["home", "בית"],
  ["journal", "יומן ויזואלי"],
  ["cards", "קלפי נפש"],
  ["visionboard", "לוח חזון"],
  ["workshops", "סדנאות"],
  ["about", "אודות"],
  ["contact", "צרי קשר"],
];

export default function TopNavbar({ navigate, currentPage }) {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);

  useEffect(() => {
    const onScroll = () => setY(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (page) => {
    toggleSidebar(false);
    if (navigate) navigate(page);
  };

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} navigate={navigate} currentPage={currentPage} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper className={`flexCenter${y > 100 ? " scrolled" : ""}`}>
        <NavInner>
          {/* RTL: logo on the right, then the tabs from "בית" to "צרי קשר" */}
          <UlWrapperRight className="flexNullCenter">
            <LogoBtn onClick={() => handleNav("home")} className="pointer flexNullCenter">
              <img src={LogoWithText} alt="הלב הצבעוני" />
            </LogoBtn>
          </UlWrapperRight>

          <UlWrapper className="flexNullCenter">
            {TABS.map(([page, label]) => {
              const active = currentPage === page || (page === "home" && !currentPage);
              return (
                <li key={page} className="font15 pointer" onClick={() => handleNav(page)}>
                  <NavBtn
                    className={`${active ? "activeTab" : ""}${page === "contact" ? " ctaTab" : ""}`}
                    aria-current={active ? "page" : undefined}
                  >
                    {label}
                  </NavBtn>
                </li>
              );
            })}
          </UlWrapper>

          <BurderWrapper className="pointer" aria-label="תפריט" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 84px;
  background:
    radial-gradient(45% 160% at 100% 0%, rgba(255, 255, 255, 0.45), transparent 70%),
    rgba(255, 167, 236, 0.96);
  backdrop-filter: blur(16px) saturate(1.3);
  -webkit-backdrop-filter: blur(16px) saturate(1.3);
  box-shadow: 0 8px 24px -14px rgba(73, 8, 57, 0.35);
  transition: height 0.5s var(--ease-out), box-shadow 0.5s var(--ease-out);
  /* pink → carrot line under the bar */
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background: linear-gradient(90deg, var(--carrot), var(--pink), var(--plum));
  }
  &.scrolled {
    height: 66px;
    box-shadow: 0 14px 34px -12px rgba(73, 8, 57, 0.4);
  }
  img {
    height: 58px;
    width: auto;
    transition: height 0.5s var(--ease-out), transform 0.5s var(--ease-spring);
  }
  &.scrolled img { height: 44px; }
`;
const NavInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0 28px; /* full width — logo flush right, tabs centred */
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  @media (max-width: 960px) { grid-template-columns: 1fr auto; }
  @media (max-width: 859px) { padding: 0 16px; }
`;
const NavBtn = styled.span`
  display: inline-block;
  cursor: pointer;
  position: relative;
  padding: 9px 18px;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--plum);
  border: 1.5px solid transparent;
  transition:
    color 0.3s var(--ease-out),
    background-color 0.3s var(--ease-out),
    border-color 0.3s var(--ease-out),
    box-shadow 0.4s var(--ease-out),
    transform 0.4s var(--ease-spring);
  &:hover {
    color: var(--pink);
    background-color: rgba(255, 255, 255, 0.55);
    border-color: rgba(203, 29, 133, 0.35);
    transform: translateY(-2px);
  }
  &.activeTab {
    color: #fff;
    background-color: var(--pink);
    border-color: var(--pink);
    box-shadow: 0 6px 18px -4px rgba(203, 29, 133, 0.75);
  }
  /* "צרי קשר" — the carrot call-to-action */
  &.ctaTab {
    color: var(--plum);
    background-color: var(--carrot);
    border-color: var(--carrot);
    box-shadow: 0 6px 18px -6px rgba(255, 160, 136, 0.8);
  }
  &.ctaTab:hover {
    color: var(--plum);
    background-color: #FF8F74;
    border-color: #FF8F74;
  }
  &.ctaTab.activeTab {
    color: #fff;
    box-shadow: 0 0 0 3px var(--plum), 0 6px 18px -6px rgba(255, 160, 136, 0.8);
  }
`;
const LogoBtn = styled.button`
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  &:hover img { transform: scale(1.04) rotate(-1deg); }
`;
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  justify-self: end; /* menu button on the far (left) side */
  display: none;
  @media (max-width: 960px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  align-items: center;
  gap: 6px;
  @media (max-width: 1100px) {
    gap: 2px;
    span { padding: 8px 12px; }
  }
  @media (max-width: 960px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul``;
